/**
 * $.uiCalendar() plugin.
 *
 * Attention! In places this component is written on Vanilla JS.
 *            This is necessary for its optimization.
 *            Please be careful when making any edits.
 *
 * Options:
 *  $wrapper: jq object
 *
 *  month_first: string
 *  month_count: null|int (default: 6)
 *  scrollbar_is_needed: bool (default: true)
 *
 *  is_range: bool (default: false)
 *
 *  date_first: string (mysql-datetime, default: null)
 *  date_second: string (mysql-datetime, default: null)
 *  is_date_second_primary: bool, (default: false)
 *
 *  show_calendar_type_select: bool (default: true)
 *  show_bottom_button_ow: bool (default: false)
 *  show_bottom_notice: bool (default: false)
 *
 *  onDayMouseenter($day_wrapper, day_parsed, dates, event): callback
 *  onDayMouseleave($day_wrapper, dates, event): callback
 *  onDaySelect($day_wrapper, day_parsed, dates, that.is_date_second_primary, event): callback
 *
 *  onRender(that): callback
 *  onFinish(that, dates): callback
 */
(function ($) {
    var UICalendar = (function ($) {

        UICalendar = function (options) {
            var that = this;

            that.class = {
                scroll_wrapper: 'scroll-wrapper',

                calendar_wrapper: 'calendar-wrapper',
                calendar: 'calendar',

                month_list_wrapper: 'month-list-wrapper',
                month_list: 'month-list',
                month_item: 'month-item',
                active: 'active',

                calendar_month_list_wrapper: 'calendar-month-list-wrapper',
                calendar_month_list_header: 'calendar-month-list-header',

                calendar_type_select_wrapper: 'calendar-type-select-wrapper',
                calendar_type_ow: 'js-calendar-type-ow',
                calendar_type_rt: 'js-calendar-type-rt',

                calendar_weekdays: 'calendar-weekdays',
                calendar_weekday: 'calendar-weekday',

                calendar_month_list: 'calendar-month-list',
                calendar_month: 'calendar-month',
                calendar_row: 'calendar-row',
                calendar_row_month: 'calendar-row-month',
                calendar_month_name: 'calendar-month-name',

                day_wrapper: 'day-wrapper',
                day: 'day',
                day_label: 'day-label',

                holiday: 'holiday',
                selected: 'selected',
                selected_first: 'selected-first',
                selected_second: 'selected-second',
                in_range: 'in-range',
                disabled: 'disabled',
                inactive: 'inactive',

                bottom_buttons_wrapper: 'bottom-buttons-wrapper',
                bottom_notice: 'bottom-notice'
            };

            that.data_keys = {
                month: {
                    name: 'month',
                    attr: 'data-month',
                },
                date: {
                    name: 'date',
                    attr: 'data-date',
                }
            };

            that.icons = {
                prohibit: '<i class="fab fa-sa-prohibit"></i>'
            }

            // DOM
            that.$wrapper = options['$wrapper'];

            // CONST
            that.month_first = options['month_first'];
            that.month_count = options['month_count'] || 6;
            that.scrollbar_is_needed = (options['scrollbar_is_needed'] !== false); // default true;
            that.is_drawer = options['is_drawer'] || false;
            that.first_enabled_date = options['first_enabled_date'] || null;
            that.last_enabled_date = options['last_enabled_date'] || null;

            that.show_calendar_type_select = (options['show_calendar_type_select'] !== false); // default true;
            that.show_bottom_button_ow = options['show_bottom_button_ow'] || false;
            that.show_bottom_notice = options['show_bottom_notice'] || false;

            that.day_modifiers_non_basic = [
                that.class.inactive
            ];

            that.onDayMouseenter = (options['onDayMouseenter'] || function () {
            });
            that.onDayMouseleave = (options['onDayMouseleave'] || function () {
            });
            that.onDaySelect = (options['onDaySelect'] || function () {
            });
            that.onRender = (options['onRender'] || function () {
            });
            that.onFinish = (options['onFinish'] || function () {
            });

            that.server_day = dayjs($.sa.server_datetime);
            that.server_last_disabled_day = that.server_day.add(-2, 'day');
            that.first_enabled_date = that.first_enabled_date ? dayjs(that.first_enabled_date) : null;
            that.last_enabled_date = that.last_enabled_date ? dayjs(that.last_enabled_date) : null;

            // DYNAMIC VARS            
            that.$calendar_wrapper = null;
            that.is_range = options['is_range'] || false;

            that.date_first = options['date_first'] || null;
            that.date_second = options['date_second'] || null;
            that.is_date_second_primary = that.is_range ? options['is_date_second_primary'] || false : false;

            // INIT
            that.init();
        };

        UICalendar.prototype.init = function () {
            var that = this;

            if (that.$calendar_wrapper) {
                return;
            }

            //console.time('__initCalendar');
            that.__initCalendar();
            that.onRender(that);
            //console.timeEnd('__initCalendar');

            //
            that.$calendar_wrapper = that.$wrapper.find('.' + that.class.calendar_wrapper);

            //
            that.__initStartDates();

            //
            that.__initScrollbar();

            //
            that.__initDayHandlers();
            that.__initSelectTypeHandlers();
        };

        //

        UICalendar.prototype.setupScrollbarHeight = function () {
            var that = this;

            that.__setupScrollbarHeight();
        }

        UICalendar.prototype.setDateSecondIsPrimary = function (value) {
            var that = this;

            that.is_date_second_primary = value;
        };

        UICalendar.prototype.setDayLabels = function (days_options) {
            var that = this;

            if (!days_options) {
                return;
            }

            for (var date in days_options) {
                if (!date) {
                    continue;
                }
                var day_options = days_options[date];
                if (!day_options) {
                    continue;
                }
                var label = day_options.label;
                if (!label) {
                    continue;
                }

                var $day_wrapper = that.__getNode(that.class.day_wrapper + '[data-date=' + date + ']');
                if (!$day_wrapper || !$day_wrapper.length) {
                    continue;
                }

                var label_text = label.value || '',
                    label_modifiers = label.modifiers || [];

                // label
                var day_label = $day_wrapper.find('.' + that.class.day_label).get(0);
                if (!day_label) {
                    day_label = document.createElement('span');
                }
                // set modifiers
                // but firstly clear all classes from node (to override existing modifiers)
                day_label.className = '';
                // append class `that.class.day_label` along with modifiers
                day_label.classList.add(that.class.day_label, ...label_modifiers);
                // set label text
                day_label.textContent = label_text;

                if (!that.is_drawer) {
                    // tooltip
                    var tooltip = $day_wrapper.find('.tooltip').get(0),
                        tooltip_title = tooltip ? tooltip.querySelector('.title') : null;

                    if (tooltip && !tooltip_title) {
                        tooltip_title = document.createElement('div');
                        tooltip_title.classList.add('title');
                        tooltip.prepend(tooltip_title);
                    }
                    tooltip_title.textContent = label_text;
                }

                $day_wrapper.append(day_label);
            }
        };

        UICalendar.prototype.clearDateLabels = function () {
            var that = this,
                $day_wrappers = that.__getNode(that.class.day_wrapper + ':not(.' + that.class.disabled + ')'),
                $day_labels = $day_wrappers.find('.' + that.class.day_label),
                $day_tooltip_titles = $day_wrappers.find('.tooltip .title');
            $day_labels.html('');
            $day_tooltip_titles.html('');
        };

        UICalendar.prototype.updateDays = function (days_options) {
            var that = this;

            if (!days_options) {
                return;
            }

            // if there are modifiers:
            // firstly, clear all non-protected modifiers from all dates
            that.clearDaysModifiers();

            for (var date in days_options) {
                var day_options = days_options[date];
                if (!day_options) {
                    continue;
                }

                var $day_wrapper = (date !== 'all')
                    ? that.__getNode(that.class.day_wrapper + '[data-date=' + date + ']')
                    : that.__getNode(that.class.day_wrapper);

                if (!$day_wrapper || !$day_wrapper.length) {
                    continue;
                }

                // Update day modifiers
                if (Array.isArray(day_options.modifiers)) {
                    $day_wrapper.addClass(day_options.modifiers.join(' '));
                }
            }
        };

        UICalendar.prototype.clearDaysModifiers = function () {
            var that = this;
            that.__getNode(that.class.day_wrapper).each(function () {
                that.__clearDayModifiers(this);
            });
        };

        UICalendar.prototype.scrollToDay = function ($day_wrapper) {
            var that = this,
                $calendar_month_list = that.__getNode(that.class.calendar_month_list),
                position = 0;

            // firstly reset scroll position
            $calendar_month_list.scrollTop(0);

            if ($day_wrapper.length) {
                var day_wrapper_height = $day_wrapper.outerHeight(),
                    day_wrapper_offset = day_wrapper_height * 2.5;
                position = $day_wrapper.offset().top - $calendar_month_list.offset().top + $calendar_month_list.scrollTop();
                if (day_wrapper_offset > position) {
                    position = 0;
                } else if (position > day_wrapper_offset) {
                    position -= day_wrapper_offset;
                }
            }
            $calendar_month_list.scrollTop(position);
        };

        UICalendar.prototype.getFirstSelectedDay = function () {
            var that = this,
                $calendar_month_list = that.__getNode(that.class.calendar_month_list);

            return $calendar_month_list.find(
                '.' + that.class.day_wrapper +
                '.' + that.class.selected + ':first'
            );
        };

        UICalendar.prototype.getFirstActiveDay = function () {
            var that = this,
                $calendar_month_list = that.__getNode(that.class.calendar_month_list);

            return $calendar_month_list.find(
                '.' + that.class.day_wrapper +
                ':not(.' + that.class.disabled + ')' +
                ':not(.' + that.class.inactive + '):first'
            );
        };

        //

        UICalendar.prototype.__initCalendar = function () {
            var that = this;

            var calendar_wrapper = document.createElement('div');
            calendar_wrapper.classList.add(that.class.calendar_wrapper);

            var calendar = document.createElement('div');
            calendar.classList.add(that.class.calendar);

            var calendar_fragment = document.createDocumentFragment();
            calendar_fragment.appendChild(that.__buildMonthList());
            calendar_fragment.appendChild(that.__buildCalendarMonthList());
            calendar.appendChild(calendar_fragment);

            calendar_wrapper.appendChild(calendar);

            that.$wrapper.html(calendar_wrapper);
        };

        UICalendar.prototype.__buildMonthList = function () {
            var that = this;

            var month_list_wrapper = document.createElement('div');
            month_list_wrapper.classList.add(that.class.month_list_wrapper);

            var month_list = document.createElement('div');
            month_list.classList.add(that.class.month_list);

            month_list_wrapper.appendChild(month_list);

            var month_list_fragment = document.createDocumentFragment(),
                last_rendered_year = null;

            for (var i = 0; that.month_count > i; i++) {
                var month_item = document.createElement('div');
                month_item.classList.add(that.class.month_item);

                var month_datetime = dayjs(that.month_first).add(i, 'month'),
                    month = $.sa.parseDatetime(month_datetime),
                    month_label = month.month.name_full;
                if (last_rendered_year && last_rendered_year !== month.year.full) {
                    month_label += ' ' + month.year.full;
                }
                last_rendered_year = month.year.full;

                month_item.textContent = month_label;
                month_item.setAttribute(that.data_keys.month.attr, month.month.sql);

                month_list_fragment.appendChild(month_item);
            }

            month_list.appendChild(month_list_fragment);

            return month_list_wrapper;
        }

        UICalendar.prototype.__buildCalendarMonthList = function () {
            var that = this;

            var calendar_month_list_wrapper = document.createElement('div');
            calendar_month_list_wrapper.classList.add(that.class.calendar_month_list_wrapper);

            var calendar_month_list_wrapper_fragment = document.createDocumentFragment();

            // Header
            calendar_month_list_wrapper_fragment.appendChild(that.__buildCalendarMonthListHeader());

            // Scroll + calendar months
            var scroll_wrapper = document.createElement('div');
            scroll_wrapper.classList.add(that.class.scroll_wrapper);
            scroll_wrapper.appendChild(that.__buildCalendarMonths());
            calendar_month_list_wrapper_fragment.appendChild(scroll_wrapper);
            calendar_month_list_wrapper_fragment.appendChild(that.__buildCalendarBottomButtons());

            //
            calendar_month_list_wrapper.appendChild(calendar_month_list_wrapper_fragment);
            return calendar_month_list_wrapper;
        }

        UICalendar.prototype.__buildCalendarMonthListHeader = function () {
            var that = this;

            function buildCalendarTypeSelect() {
                function buildCalendarTypeItem(title, value) {
                    var input = document.createElement('input');
                    input.classList.add('js-select-button-input');
                    input.setAttribute('type', 'radio');
                    input.setAttribute('name', 'type');
                    input.setAttribute('value', value);
                    if (value === 'rt') {
                        input.checked = true;
                        input.classList.add(that.class.calendar_type_rt);
                    } else {
                        input.classList.add(that.class.calendar_type_ow);
                    }

                    var label = document.createElement('span');
                    label.classList.add('content');
                    label.textContent = title;

                    var item = document.createElement('label');
                    item.classList.add('item');

                    var item_fragment = document.createDocumentFragment();
                    item_fragment.appendChild(input);
                    item_fragment.appendChild(label);

                    item.appendChild(item_fragment);

                    return item;
                }

                var type_select_wrapper = document.createElement('div');
                type_select_wrapper.classList.add(
                    that.class.calendar_type_select_wrapper,
                    'select-button',
                    'full',
                    'secondary',
                    'small',
                    'js-select-button'
                );

                var type_select_items = document.createElement('div');
                type_select_items.classList.add('items');

                var type_select_items_fragment = document.createDocumentFragment();
                type_select_items_fragment.appendChild(buildCalendarTypeItem($.sa.locales['trip_type']['rt'], 'rt'));
                type_select_items_fragment.appendChild(buildCalendarTypeItem($.sa.locales['trip_type']['ow'], 'ow'));

                type_select_items.appendChild(type_select_items_fragment);
                type_select_wrapper.appendChild(type_select_items);
                return type_select_wrapper;
            }

            function buildCalendarWeekdays() {
                var calendar_weekdays = document.createElement('div');
                calendar_weekdays.classList.add(that.class.calendar_weekdays);

                var weekdays_fragment = document.createDocumentFragment();

                for (var i = 1; i <= 7; i++) {
                    var weekday_index = i === 7 ? 0 : i,
                        is_holiday = i > 5,
                        weekday_short_name = $.sa.locales.weekdays.short[weekday_index];

                    var weekday = document.createElement('div');
                    weekday.textContent = weekday_short_name;
                    weekday.classList.add(that.class.calendar_weekday);
                    if (is_holiday) {
                        weekday.classList.add(that.class.holiday);
                    }
                    weekdays_fragment.appendChild(weekday);
                }

                calendar_weekdays.appendChild(weekdays_fragment);
                return calendar_weekdays;
            }

            var calendar_month_list_header = document.createElement('div');
            calendar_month_list_header.classList.add(that.class.calendar_month_list_header);

            var calendar_month_list_header_fragment = document.createDocumentFragment();

            if (that.show_calendar_type_select) {
                calendar_month_list_header_fragment.appendChild(buildCalendarTypeSelect());
            }
            calendar_month_list_header_fragment.appendChild(buildCalendarWeekdays());

            calendar_month_list_header.appendChild(calendar_month_list_header_fragment);
            return calendar_month_list_header;
        }

        UICalendar.prototype.__buildCalendarMonths = function () {
            var that = this;

            var calendar_month_list = document.createElement('div');
            calendar_month_list.classList.add(that.class.calendar_month_list);

            var calendar_month_list_fragment = document.createDocumentFragment();
            for (var i = 0; that.month_count > i; i++) {
                var month_day = dayjs(that.month_first).startOf('month').add(i, 'month');
                calendar_month_list_fragment.appendChild(that.__buildCalendarMonth(month_day));
            }

            calendar_month_list.appendChild(calendar_month_list_fragment);
            return calendar_month_list;
        }

        UICalendar.prototype.__buildCalendarMonth = function (month_day) {
            var that = this,
                month_day_parsed = $.sa.parseDatetime(month_day);

            var calendar_month = document.createElement('div');
            calendar_month.classList.add(that.class.calendar_month);
            calendar_month.setAttribute(that.data_keys.month.attr, month_day_parsed.month.sql);

            var calendar_month_fragment = document.createDocumentFragment();

            // Build month name

            var calendar_month_name = document.createElement('div');
            calendar_month_name.classList.add(that.class.calendar_month_name);
            calendar_month_name.textContent = month_day_parsed.month.name_full + ' ' + month_day_parsed.year.full;
            var calendar_month_name_row = document.createElement('div');
            calendar_month_name_row.classList.add(that.class.calendar_row, that.class.calendar_row_month);

            calendar_month_name_row.appendChild(calendar_month_name);
            calendar_month_fragment.appendChild(calendar_month_name_row);

            // Build month weeks data
            var month_first_day = month_day.startOf('month'),
                month_last_day = month_day.endOf('month'),

                current_day = month_first_day,
                week = 0, // week of month
                weeks = [];

            while (current_day < month_last_day) {
                var week_days = [];

                // day of week
                for (var d = 1; d <= 7; d++) {
                    var current_day_parsed = $.sa.parseDatetime(current_day),
                        current_day_week_index = current_day_parsed.day.week_index;
                    current_day_week_index = current_day_week_index === 0 ? 7 : current_day_week_index; // Crutch for Sunday

                    if (
                        month_day_parsed.month.sql !== current_day_parsed.month.sql ||
                        (week === 0 && current_day_week_index > d)
                    ) {
                        week_days.push(null);
                    } else {
                        week_days.push(current_day);
                        current_day = current_day.add(1, 'day');
                    }
                }

                weeks.push(week_days);
                week++;
            }

            // Build month week rows
            $.each(weeks, function (i, week) {
                var week_row = document.createElement('div');
                week_row.classList.add(that.class.calendar_row);

                var week_row_fragment = document.createDocumentFragment();

                $.each(week, function (i, day) {
                    var is_disabled = !day || day.isBefore(that.server_last_disabled_day) ||
                        (that.first_enabled_date && day.isBefore(that.first_enabled_date)) ||
                        (that.last_enabled_date && day.isAfter(that.last_enabled_date));
                    week_row_fragment.appendChild(
                        that.__buildDay(
                            day,
                            null,
                            false,
                            false,
                            false,
                            is_disabled
                        )
                    );
                });

                week_row.appendChild(week_row_fragment);
                calendar_month_fragment.appendChild(week_row);
            });

            calendar_month.appendChild(calendar_month_fragment);
            return calendar_month;
        }

        UICalendar.prototype.__buildDay = function (
            day,
            label = null,
            is_selected = false,
            in_range = false,
            is_holiday = false,
            is_disabled = false
        ) {
            var that = this;

            var day_wrapper = document.createElement('div');
            day_wrapper.classList.add(that.class.day_wrapper);
            if (null === day) {
                day_wrapper.classList.add(that.class.disabled);
                return day_wrapper;
            }
            day_wrapper.setAttribute(that.data_keys.date.attr, day.format('YYYY-MM-DD'));
            that.__setupDay(day_wrapper, label, is_selected, in_range, is_holiday, is_disabled);
            return day_wrapper;
        }

        UICalendar.prototype.__setupDay = function (
            day_wrapper,
            label = null,
            is_selected = false,
            in_range = false,
            is_holiday = null,
            is_disabled = null
        ) {
            var that = this,
                day_date = day_wrapper.getAttribute(that.data_keys.date.attr);
            if (!day_date) {
                return;
            }
            var day_parsed = $.sa.parseDatetime(day_date),
                day_wrapper_fragment = document.createDocumentFragment();

            if (day_wrapper.hasChildNodes()) {
                day_wrapper.innerHtml = '';
            }

            // Setup tooltip
            if (!that.is_drawer) {
                day_wrapper.classList.add('tooltip-wrapper');
                var tooltip = document.createElement('div');
                tooltip.classList.add('tooltip', 'small', 'bottom');
                var tooltip_fragment = document.createDocumentFragment(),
                    tooltip_title = null,
                    tooltip_sub_title = null;

                if (!!is_disabled) {
                    tooltip_title = document.createElement('div');
                    tooltip_title.classList.add('title');
                    tooltip_title.innerHTML = that.icons.prohibit;
                } else {
                    if (label) {
                        tooltip_title = document.createElement('div');
                        tooltip_title.classList.add('title');
                        tooltip_title.textContent = label;
                    }

                    tooltip_sub_title = document.createElement('div');
                    tooltip_sub_title.classList.add('sub-title');
                    tooltip_sub_title.textContent = day_parsed.day.number + ' ' + day_parsed.month.name_short;
                }

                if (tooltip_title) {
                    tooltip_fragment.appendChild(tooltip_title);
                }
                if (tooltip_sub_title) {
                    tooltip_fragment.appendChild(tooltip_sub_title);
                }
                tooltip.appendChild(tooltip_fragment);
                day_wrapper_fragment.appendChild(tooltip);
            }

            // Setup day
            var day = document.createElement('span');
            day.classList.add(that.class.day);
            day.textContent = day_parsed.day.number;
            day_wrapper_fragment.appendChild(day);

            //

            if (!is_holiday && $.inArray(day_parsed.day.week_index, [0, 6]) !== -1) {
                is_holiday = true;
            }
            if (null !== is_holiday) {
                day_wrapper.classList.toggle(that.class.holiday, is_holiday);
            }
            if (null !== is_disabled) {
                day_wrapper.classList.toggle(that.class.disabled, is_disabled);
            }

            //

            day_wrapper.appendChild(day_wrapper_fragment);
        }

        UICalendar.prototype.__clearDayModifiers = function (day_wrapper) {
            var that = this,
                class_list = day_wrapper.classList;

            for (var i = 0; i < class_list.length; i++) {
                var class_item = class_list[i];
                if (!class_item) {
                    continue;
                }
                if (true === that.day_modifiers_non_basic.includes(class_item)) {
                    day_wrapper.classList.remove(class_item);
                }
            }
        };

        UICalendar.prototype.__buildCalendarBottomButtons = function () {
            var that = this;

            // Wrapper
            var bottom_buttons = document.createElement('div');
            bottom_buttons.classList.add(that.class.bottom_buttons_wrapper);

            //
            var bottom_buttons_fragment = document.createDocumentFragment();

            // Button OW
            var button_ow = document.createElement('button');
            button_ow.style.display = 'none';
            button_ow.classList.add('button', 'ghost', 'thin', that.class.calendar_type_ow);
            button_ow.setAttribute('tabindex', '-1');
            button_ow.textContent = $.sa.locales['dont_needed_return_ticket'];

            // Button Continue
            var button_continue = document.createElement('button');
            button_continue.style.display = 'none';
            button_continue.classList.add('button', 'js-close');
            button_continue.textContent = $.sa.locales['continue'];

            //
            bottom_buttons_fragment.appendChild(button_ow);
            bottom_buttons_fragment.appendChild(button_continue);

            //
            bottom_buttons.appendChild(bottom_buttons_fragment);
            if (that.show_bottom_notice) {
                bottom_buttons.appendChild(that.__buildBottomNotice());
            }

            return bottom_buttons;
        };

        //

        UICalendar.prototype.__setupCalendarBottomButtons = function () {
            var that = this,
                $button_ow = that.__getNode('button.' + that.class.calendar_type_ow),
                $button_continue = that.__getNode('js-close');

            if (that.show_bottom_button_ow && !that.is_drawer) {
                $button_ow.show();
            }

            if (!that.is_drawer) {
                return false;
            }

            if (!that.is_range) {
                $button_ow.hide();
                if (that.date_first || that.date_second) {
                    $button_continue.show();
                } else {
                    $button_continue.hide();
                }
            } else {
                if (that.date_first && that.date_second) {
                    $button_ow.hide();
                    $button_continue.show();
                } else if (!that.date_first || !that.date_second) {
                    $button_continue.hide();
                    $button_ow.show();
                } else {
                    $button_continue.hide();
                    $button_ow.hide();
                }
            }

            that.__setupScrollbarHeight();
        };

        UICalendar.prototype.__setupCalendarButtonOw = function () {
            var that = this,
                $button_ow = that.__getNode('button.' + that.class.calendar_type_ow);

            if (!that.is_drawer) {
                $button_ow.prop('disabled', !that.date_first);
            }
        };

        UICalendar.prototype.__buildBottomNotice = function () {
            var that = this,
                bottom_notice = document.createElement('div');

            bottom_notice.classList.add(that.class.bottom_notice);
            bottom_notice.textContent = $.sa.locales['indicated_prices_one_way'];

            return bottom_notice;
        };

        UICalendar.prototype.__setActiveDates = function (dates) {
            var that = this,
                $calendar_month_list = that.__getNode(that.class.calendar_month_list);

            // Below, the selectors are collected into an array, so that they can then be glued together and passed to find().
            // This is intended to reduce the number of expensive find() calls.

            // Reset statuses for all days
            var reset_selectors = [
                '.' + that.class.day_wrapper + '.' + that.class.in_range,
                '.' + that.class.day_wrapper + '.' + that.class.selected,
            ];
            $calendar_month_list.find(reset_selectors.join(','))
                .removeClass(that.class.in_range)
                .removeClass(that.class.selected)
                .removeClass(that.class.selected_first)
                .removeClass(that.class.selected_second);

            // Set statuses 'is_selected' for active days
            var not_empty_date_items = [...new Set(dates)].filter(d => !!d);
            $.each(dates, function (i, date) {
                var $day_wrapper = $calendar_month_list.find('.' + that.class.day_wrapper + '[' + that.data_keys.date.attr + '="' + date + '"]');
                $day_wrapper.addClass(that.class.selected);

                if (not_empty_date_items.length > 1) {
                    if (i === 0) {
                        $day_wrapper.addClass(that.class.selected_first);
                    } else {
                        $day_wrapper.addClass(that.class.selected_second);
                    }
                }
            });

            // Highlight the days in between
            if (dates[0] && dates[1]) {
                var day1 = dayjs(dates[0]),
                    day2 = dayjs(dates[1]),
                    diff = day2.diff(day1, 'day');

                var range_selectors = [];
                for (var i = 1; i < diff; i++) {
                    var range_date = day2.add(-i, 'day').format('YYYY-MM-DD');
                    range_selectors.push('.' + that.class.day_wrapper + '[' + that.data_keys.date.attr + '="' + range_date + '"]');
                }
                if (range_selectors.length) {
                    $calendar_month_list.find(range_selectors.join(',')).addClass(that.class.in_range);
                }
            }
        };

        UICalendar.prototype.__initStartDates = function () {
            var that = this,
                dates = [that.date_first];
            if (that.is_range) {
                dates.push(that.date_second);
            }
            that.__setActiveDates(dates);
            that.__setupCalendarBottomButtons();
            that.__setupCalendarButtonOw();
        }

        UICalendar.prototype.__initScrollbar = function () {
            var that = this;

            if (!that.scrollbar_is_needed) {
                return false;
            }

            //
            that.__setupScrollbarHeight();

            //
            var $calendar_month_list = that.__getNode(that.class.calendar_month_list),
                $calendar_months = that.$wrapper.find('.'+that.class.calendar_month),
                $month_list = that.__getNode(that.class.month_list),
                $month_items = $month_list.find('.'+that.class.month_item);
            
            function __setActiveMonth(month) {
                var $month_item = $month_list.find('.'+that.class.month_item+'[data-'+that.data_keys.month.name+'="'+month+'"]');
                $month_items.removeClass(that.class.active);
                $month_item.addClass(that.class.active);
            }
            
            $.uiScrollbar(
                $calendar_month_list,
                null,
                {
                    onScroll: function () {
                        $.each($calendar_months, function () {
                            var $calendar_month = $(this),
                                month = $calendar_month.data(that.data_keys.month.name),
                                height = $calendar_month.outerHeight(),
                                top_offset = $calendar_month.offset().top - $calendar_month_list.offset().top + $calendar_month_list.scrollTop(),
                                offset_y = $calendar_month_list.scrollTop();

                            if (
                                top_offset < offset_y &&
                                top_offset + height > offset_y
                            ) {
                                __setActiveMonth(month);
                                return false;
                            }
                        });
                    }
                }
            );

            //
            that.__setupScrollbarHeight();

            // Scroll to the first active or selected day
            var $day_to_scroll = that.getFirstSelectedDay();
            if (!$day_to_scroll.length) {
                $day_to_scroll = that.getFirstActiveDay();
            }
            that.scrollToDay($day_to_scroll);
            
            // Scroll to the month
            $month_list.on('click', '.'+that.class.month_item, function () {
                var $month_item = $(this),
                    month = $month_item.data(that.data_keys.month.name),
                    $calendar_month_item = $calendar_month_list.find('.'+that.class.calendar_month+'[data-'+that.data_keys.month.name+'="'+month+'"]');
                
                if ($calendar_month_item.length) {
                    var calendar_month_item_height = $day_to_scroll.height() - 46,
                        position = $calendar_month_item.offset().top - $calendar_month_list.offset().top + $calendar_month_list.scrollTop();
                    if (position > calendar_month_item_height) {
                        position -= calendar_month_item_height;
                    }
                    $calendar_month_list.scrollTop(position);
                    __setActiveMonth(month);
                }
            });
        };

        UICalendar.prototype.__setupScrollbarHeight = function () {
            var that = this;

            if (!that.scrollbar_is_needed) {
                return false;
            }

            var $calendar_scroll_wrapper = that.__getNode(that.class.scroll_wrapper),
                $calendar_month_list_header = that.__getNode(that.class.calendar_month_list_header),
                $calendar_drawer_content_wrapper = that.$wrapper.parents('.drawer-content-wrapper');

            var wrapper_h = !$calendar_drawer_content_wrapper.length ? that.$wrapper.outerHeight() : $calendar_drawer_content_wrapper.outerHeight(),
                header_h = $calendar_month_list_header.outerHeight() || 0,
                list_h = wrapper_h - header_h;

            var $bottom_buttons = that.__getNode(that.class.bottom_buttons_wrapper);
            if ($bottom_buttons.length) {
                list_h += -$bottom_buttons.outerHeight();
            }
            $calendar_scroll_wrapper.css({'max-height': list_h});

            var $calendar_scrollbar_content = $calendar_scroll_wrapper.find('.scroll-content');
            if ($calendar_scrollbar_content.length) {
                $calendar_scrollbar_content.css({'max-height': list_h});
            }
        };

        UICalendar.prototype.__initDayHandlers = function () {
            var that = this,
                $calendar_month_list_wrapper = that.__getNode(that.class.calendar_month_list_wrapper),
                day_wrapper_selector = '.' + that.class.day_wrapper + ':not(.' + that.class.disabled + ')',
                $day_wrappers = $calendar_month_list_wrapper.find(day_wrapper_selector);

            $day_wrappers
                .on('mouseenter', function (event) {
                    var $day_wrapper = $(this),
                        date = $day_wrapper.data(that.data_keys.date.name),
                        date_first = that.date_first,
                        date_second = that.date_second,
                        tmp_is_date_second_primary = that.is_date_second_primary;

                    if (!that.is_range) {
                        date_first = date;
                    } else {
                        if (!that.date_first && !that.is_date_second_primary) {
                            date_first = date;
                            if (that.date_second && dayjs(date).isAfter(dayjs(that.date_second))) {
                                date_first = that.date_second;
                                date_second = date;
                                tmp_is_date_second_primary = true;
                            }
                        } else if (!that.date_second && that.is_date_second_primary) {
                            date_second = date;
                            if (that.date_first && dayjs(date).isBefore(dayjs(that.date_first))) {
                                date_second = that.date_first;
                                date_first = date;
                                tmp_is_date_second_primary = false;
                            }
                        } else if (that.date_first && !that.is_date_second_primary) {
                            date_first = date;
                            tmp_is_date_second_primary = false;
                            if (that.date_second && dayjs(date_first).isAfter(dayjs(date_second))) {
                                date_second = null;
                            }
                        } else if (dayjs(date).isBefore(dayjs(that.date_first))) {
                            date_second = that.date_first;
                            date_first = date;
                            tmp_is_date_second_primary = false;
                        } else {
                            date_second = date;
                            tmp_is_date_second_primary = true;
                        }
                    }

                    var dates = [date_first];
                    if (that.is_range) {
                        dates.push(date_second);
                    }

                    that.__setActiveDates(dates);
                    if (!that.is_drawer) {
                        that.onDayMouseenter($day_wrapper, date, dates, tmp_is_date_second_primary, event);
                        that.__setupCalendarButtonOw();
                    }
                })
                .on('mouseleave', function (event) {
                    var $day_wrapper = $(this),
                        dates = [that.date_first];

                    if (that.is_range) {
                        dates.push(that.date_second);
                    }

                    that.__setActiveDates(dates);
                    if (!that.is_drawer) {
                        that.onDayMouseleave($day_wrapper, dates, that.is_date_second_primary, event);
                        that.__setupCalendarButtonOw();
                    }
                })
                .on('click', function (event) {
                    var $day_wrapper = $(this),
                        date = $day_wrapper.data(that.data_keys.date.name);

                    if (!that.is_range) {
                        that.date_first = date;
                    } else {
                        if (!that.date_first && !that.is_date_second_primary) {
                            that.date_first = date;
                            that.is_date_second_primary = true;
                            if (that.date_second && dayjs(date).isAfter(dayjs(that.date_second))) {
                                that.date_first = that.date_second;
                                that.date_second = date;
                            }
                        } else if (!that.date_second && that.is_date_second_primary) {
                            that.date_second = date;
                            that.is_date_second_primary = false;
                            if (that.date_first && dayjs(date).isBefore(dayjs(that.date_first))) {
                                that.date_second = that.date_first;
                                that.date_first = date;
                                that.is_date_second_primary = true;
                            }
                        } else if (that.date_first && !that.is_date_second_primary) {
                            that.date_first = date;
                            that.is_date_second_primary = true;
                            if (that.date_second && dayjs(that.date_first).isAfter(dayjs(that.date_second))) {
                                that.date_second = null;
                            }
                        } else if (dayjs(date).isBefore(dayjs(that.date_first))) {
                            that.date_second = that.date_first;
                            that.date_first = date;
                        } else {
                            that.date_second = date;
                            that.is_date_second_primary = false;
                        }
                    }

                    var dates = [that.date_first];
                    if (that.is_range) {
                        dates.push(that.date_second);
                    }

                    that.__setActiveDates(dates);
                    that.__setupCalendarBottomButtons();
                    that.onDaySelect($day_wrapper, date, dates, that.is_date_second_primary, event);

                    if (!that.is_drawer) {
                        that.__setupCalendarButtonOw();
                        if (that.is_range) {
                            var not_empty_date_items = dates.filter(d => !!d);
                            if (not_empty_date_items.length === 2) {
                                that.__finish(dates);
                            }
                        } else {
                            that.__finish(dates);
                        }
                    }
                });
        }

        UICalendar.prototype.__initSelectTypeHandlers = function () {
            var that = this,
                $button_ow = that.__getNode(that.class.calendar_type_ow),
                $button_rt = that.__getNode(that.class.calendar_type_rt);

            $button_ow.on('click', function () {
                $button_ow.prop('checked', true);

                if (!that.date_first && that.date_second) {
                    that.date_first = that.date_second;
                    that.date_second = null;
                }
                that.is_range = false;

                if (that.date_first) {
                    var dates = [that.date_first];
                    that.__setActiveDates(dates);
                    that.is_date_second_primary = false;
                    that.onDaySelect(null, that.date_first, dates, that.is_date_second_primary, null);
                    that.__finish(dates);
                }
                that.__setupCalendarBottomButtons();
            });

            $button_rt.on('click', function () {
                that.is_range = true;
                that.__setupCalendarBottomButtons();
            });
        };

        //

        UICalendar.prototype.__getNode = function (selector) {
            var that = this;
            return that.$calendar_wrapper.find('.' + selector);
        };

        //

        UICalendar.prototype.__finish = function (dates) {
            var that = this;

            that.onFinish(that, dates);
        };

        return UICalendar;

    })($);

    $.uiCalendar = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);
        return new UICalendar(options);
    };
})(jQuery);

/*  Нужно создать событие когда вторая дата пустая и когда вторая дата не пустая */